module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message",
    style: ({
      color: _vm.text_color,
      borderColor: _vm.border_color,
      backgroundColor: _vm.background_color
    })
  }, [_c('span', {
    staticClass: "text"
  }, [_c('icon', {
    attrs: {
      "name": _vm.icon_name,
      "scale": "1",
      "color": _vm.icon_color
    }
  }), _vm._v(" \n      " + _vm._s(_vm.text) + "\n    ")], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-748eacde!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Message.vue
// module id = 2165
// module chunks = 0